import {useContext} from "react";
import {LocaleContext} from "@context/LocaleContext";

export const useToggleLocale = () => {
	const currentLocale = useContext(LocaleContext);
	const newLocale = currentLocale === "es" ? "en" : "es";

	return newLocale;
};
